export default __webpack_public_path__ + "static/media/a012-6.647caebc.svg";